import type { SVGProps } from 'react';

const SvgStroke = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height={2}
    viewBox='0 0 12 2'
    width={12}
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      clipRule='evenodd'
      d='M0 1c0-.552.384-1 .857-1h10.286c.473 0 .857.448.857 1s-.384 1-.857 1H.857C.384 2 0 1.552 0 1'
      fill='currentColor'
      fillRule='evenodd'
    />
  </svg>
);
export default SvgStroke;
